// import { NativeWorker, NativeWorkerService } from './nativeWorker';
import { NativeWorker, NativeWorkerService } from '../machproH5Base/native-worker';

interface Window {
  NativeWorker: typeof NativeWorker;
  NativeWorkerService: typeof NativeWorkerService;
}

// 将 NativeWorker 和 NativeWorkerService 挂载到 globalThis
if (
  typeof globalThis !== 'undefined'
) {
  if (!globalThis.NativeWorker) {
    // @ts-ignore
    globalThis.NativeWorker = NativeWorker;
  }

  if (!globalThis.NativeWorkerService) {
    // @ts-ignore
    globalThis.NativeWorkerService = NativeWorkerService;
  }
}
